module.exports = __webpack_public_path__ + "static/media/building.0dd54194.jpg";